<div class="card">
  <p-toolbar>
    <div class="p-toolbar-group-start">
      <div [id]="repeater.getElementId(RepeaterElementType.TopOfAddButton)"></div>
      <button *ngIf="repeater.buttonSettings.standard.add.isVisible()"
              pButton
              type="button"
              iconPos="left"
              [disabled]="!repeater.canAddItem()"
              [id]="repeater.getElementId(RepeaterElementType.AddButton)"
              [label]="repeater.buttonSettings.standard.add.label"
              [title]="repeater.buttonSettings.standard.add.label"
              [icon]="repeater.buttonSettings.standard.add.icon"
              (click)="repeater.addItem()">
      </button>
    </div>
  </p-toolbar>
</div>
<p-table [columns]="headerQuestions" [value]="repeater.viewModel.model" dataKey="$repeaterItemViewModelId">
  <ng-template pTemplate="header" let-tableColumns>

    <ng-container *ngIf="repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate"></ng-container>

    <ng-template #defaultLayoutTemplate>
    </ng-template>
    <ng-template #cardLayoutTemplate>
      <div class="mt-2"></div>
    </ng-template>

  </ng-template>
  <ng-template pTemplate="body" let-itemHeaderViewModel let-tableColumns="columns">
    <ng-container *ngIf="repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate"></ng-container>

    <ng-template #defaultLayoutTemplate>
    </ng-template>
    <ng-template #cardLayoutTemplate>
      <tr>
        <td>
          <div class="card widget-messages repeater-card" style="height: 100%" *ngIf=" table && !table.isRowExpanded(itemHeaderViewModel)">
            <div class="flex align-items-center justify-content-between">
              <div>
                <button *ngIf="repeater.buttonSettings.standard.edit.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        pButton
                        pRipple
                        type="button"
                        class="p-button-rounded p-button-outlined p-button-sm"
                        [disabled]="!repeater.canEditItem(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [id]="repeater.getElementId(RepeaterElementType.EditButton, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [label]="repeater.buttonSettings.standard.edit.label"
                        [title]="repeater.getButtonTitle(repeater.buttonSettings.standard.edit.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [icon]="repeater.buttonSettings.standard.edit.icon"
                        (click)="repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)">
                </button>
                <button *ngIf="repeater.buttonSettings.standard.view.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        pButton
                        pRipple
                        type="button"
                        class="p-button-rounded p-button-outlined p-button-sm"
                        [disabled]="!repeater.canViewItem(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [id]="repeater.getElementId(RepeaterElementType.ViewButton, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [label]="repeater.buttonSettings.standard.view.label"
                        [title]="repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [icon]="repeater.buttonSettings.standard.view.icon"
                        (click)="repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)">
                </button>
                <button *ngIf="repeater.buttonSettings.standard.remove.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        pButton
                        pRipple
                        type="button"
                        class="p-button-rounded p-button-outlined p-button-sm"
                        [disabled]="!repeater.canRemoveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [id]="repeater.getElementId(RepeaterElementType.RemoveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [label]="repeater.buttonSettings.standard.remove.label"
                        [title]="repeater.getButtonTitle(repeater.buttonSettings.standard.remove.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [icon]="repeater.buttonSettings.standard.remove.icon"
                        (click)="repeater.removeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)">
                </button>
                <ng-container *ngFor="let customButton of repeater.buttonSettings.custom.itemHeader">
                  <button *ngIf="customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                          pButton
                          pRipple
                          type="button"
                          class="p-button-rounded p-button-outlined p-button-sm"
                          [label]="customButton.label"
                          [title]="repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                          [icon]="customButton.icon"
                          (click)="repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)">
                  </button>
                </ng-container>
              </div>
            </div>
            <div class="mb-4" [innerHtml]="getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)">
            </div>
            <div [id]="repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)"></div>

          </div>
          <div class="card widget-messages repeater-card" style="height: 100%" *ngIf="table && table.isRowExpanded(itemHeaderViewModel)">
            <div class="flex align-items-center justify-content-between" *ngIf="!hideCustomHeaderWhenExpanded">
              <div [id]="repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)">
                <div [innerHtml]="getHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)"></div>
              </div>
            </div>
            <div *ngIf="!hideCustomSubHeaderWhenExpanded" [innerHtml]="getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)">
            </div>
            <div [id]="repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)"></div>
            <ng-container *ngIf="renderItemsAsSeparateFieldTypes; then separateFieldTypeItemTemplate; else singleFieldTypeItemTemplate"></ng-container>
            <ng-template #separateFieldTypeItemTemplate>
              <div class="grid">
                <div [class]="itemConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass" *ngFor="let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup">
                  <formly-field class="col" [field]="itemConfig"></formly-field>
                </div>
              </div>
            </ng-template>
            <ng-template #singleFieldTypeItemTemplate>
              <div *ngFor="let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup">
                <formly-field *ngIf="!isQuestionToBeIgnored(itemConfig)" class="col" [field]="itemConfig"></formly-field>
              </div>
            </ng-template>

            <div class="flex justify-content-between">
              <ng-container *ngFor="let customButton of repeater.buttonSettings.custom.itemContentLeft">
                <button *ngIf="customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        pButton
                        type="button"
                        class="p-button-secondary"
                        [label]="customButton.label"
                        [title]="repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [icon]="customButton.icon"
                        (click)="repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)">
                </button>
              </ng-container>
              <button *ngIf="repeater.buttonSettings.standard.close.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      pButton
                      type="button"
                      class="p-button-secondary"
                      [disabled]="!repeater.canCloseItem()"
                      [id]="repeater.getElementId(RepeaterElementType.CloseButton, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      [label]="repeater.buttonSettings.standard.close.label"
                      [title]="repeater.getButtonTitle(repeater.buttonSettings.standard.close.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      [icon]="repeater.buttonSettings.standard.close.icon"
                      (click)="repeater.closeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)">
              </button>
              <button *ngIf="repeater.buttonSettings.standard.save.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      pButton
                      type="button"
                      [disabled]="!repeater.canSaveItem()"
                      [id]="repeater.getElementId(RepeaterElementType.SaveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      [label]="repeater.buttonSettings.standard.save.label"
                      [title]="repeater.getButtonTitle(repeater.buttonSettings.standard.save.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                      [icon]="repeater.buttonSettings.standard.save.icon"
                      (click)="repeater.saveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)">
              </button>
              <ng-container *ngFor="let customButton of repeater.buttonSettings.custom.itemContent">
                <button *ngIf="customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        pButton
                        type="button"
                        [label]="customButton.label"
                        [title]="repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)"
                        [icon]="customButton.icon"
                        (click)="repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)">
                </button>
              </ng-container>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-itemHeaderViewModel let-tableColumns="columns">
    <ng-container *ngIf="repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate"></ng-container>
    <ng-template #defaultLayoutTemplate>
    </ng-template>
    <ng-template #cardLayoutTemplate>
      <div class="clearfix"></div>
    </ng-template>

  </ng-template>
</p-table>
